'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var manorProvider = require('@comparethemarketau/manor-provider');

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2;
var StyledPicture = styled__default.picture(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 100%;\n"])));
var StyledImg = styled__default.img(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n  object-position: ", ";\n"])), function (_ref) {
  var imgPosition = _ref.imgPosition;
  return imgPosition;
});

var Picture = function Picture(_ref) {
  var src = _ref.src,
      srcsets = _ref.srcsets,
      alt = _ref.alt,
      title = _ref.title,
      imgPosition = _ref.imgPosition,
      className = _ref.className;
  if (!src) return null;
  return /*#__PURE__*/React__default.createElement(StyledPicture, {
    className: className
  }, srcsets.map(function (source) {
    return /*#__PURE__*/React__default.createElement("source", {
      srcSet: source.srcset,
      media: source.media,
      key: source.srcset
    });
  }), /*#__PURE__*/React__default.createElement(StyledImg, {
    src: src,
    alt: alt,
    title: title,
    imgPosition: imgPosition,
    className: className
  }));
};

var picturePropTypes = {
  /**
   * src attribute for the img tag
   */
  src: PropTypes.string.isRequired,

  /**
   * srcsets attribute for the picture tag
   */
  srcsets: PropTypes.arrayOf(PropTypes.shape({
    srcset: PropTypes.string,
    media: PropTypes.string
  })),

  /**
   * alt text
   */
  alt: PropTypes.string,

  /**
   * title text
   */
  title: PropTypes.string,

  /**
   * set the object-position property
   */
  imgPosition: PropTypes.oneOf(['bottom', 'center', 'inherit', 'initial', 'left', 'revert', 'right', 'top', 'unset']),

  /**
   * Classes to be applied to the Picture component
   */
  className: PropTypes.string
};
Picture.propTypes = picturePropTypes;
Picture.defaultProps = {
  srcsets: [],
  alt: '',
  title: '',
  imgPosition: 'left',
  className: ''
};

var _templateObject$1;
var StyledLogo = styled__default.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  transition: all 200ms ease;\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme,
      size = _ref.size;
  return size === 'large' && styled.css(["height:", ";"], theme.logo.heightLarge);
}, function (_ref2) {
  var theme = _ref2.theme,
      size = _ref2.size;
  return size === 'small' && styled.css(["height:", ";"], theme.logo.heightSmall);
});

var Logo = function Logo(_ref) {
  var size = _ref.size,
      link = _ref.link,
      picture = _ref.picture,
      handleClick = _ref.handleClick;
  var src = picture.src,
      srcsets = picture.srcsets,
      alt = picture.alt,
      title = picture.title,
      className = picture.className;
  var clickHandler = React.useCallback(function (e) {
    if (handleClick) {
      handleClick(e);
    }
  }, [handleClick]);
  return /*#__PURE__*/React__default.createElement(StyledLogo, {
    size: size,
    id: "logo"
  }, /*#__PURE__*/React__default.createElement("a", {
    href: link,
    onClick: clickHandler
  }, /*#__PURE__*/React__default.createElement(Picture, {
    src: src,
    srcsets: srcsets,
    alt: alt,
    title: title,
    className: className
  })));
};

Logo.propTypes = {
  /**
   * Address for the <a> tag wrapping the logo image.
   */
  link: PropTypes.string,

  /**
   * Size of the logo (small = 3.2rem, large = 4.4rem)
   */
  size: PropTypes.oneOf(['small', 'large']),
  picture: PropTypes.shape(picturePropTypes).isRequired,
  handleClick: PropTypes.func
};
Logo.defaultProps = {
  link: 'https://www.comparethemarket.com.au',
  size: 'large',
  handleClick: null
};

/* loaded by smart-asset */
var CTMLogoInline = "ctm-logo-inline.svg";

/* loaded by smart-asset */
var CTMLogoInlineInverted = "ctm-logo-inline-inverted.svg";

/* loaded by smart-asset */
var CTMLogoStacked = "ctm-logo-stacked.svg";

/* loaded by smart-asset */
var CTMLogoStackedInverted = "ctm-logo-stacked-inverted.svg";

var CTMLogo = function CTMLogo(_ref) {
  var size = _ref.size,
      inverted = _ref.inverted,
      className = _ref.className;
  var theme = React.useContext(styled.ThemeContext);

  var _useContext = React.useContext(manorProvider.ManorContext),
      breakpoint = _useContext.breakpoint,
      trackInteraction = _useContext.trackInteraction;

  var src = CTMLogoStacked;

  if (breakpoint === 'md') {
    src = inverted ? CTMLogoStackedInverted : CTMLogoStacked;
  } else if (breakpoint !== 'xs') {
    src = inverted ? CTMLogoInlineInverted : CTMLogoInline;
  }

  var trackClickEvent = function trackClickEvent() {
    return trackInteraction('Click', 'Logo', 'CTM Logo', '', 'https://www.comparethemarket.com.au');
  };

  return /*#__PURE__*/React__default.createElement(Logo, {
    size: size,
    link: "https://www.comparethemarket.com.au",
    handleClick: trackClickEvent,
    picture: {
      src: src,
      srcsets: [{
        media: "(max-width: ".concat(theme.breakpoints.lg, ")"),
        srcset: inverted ? CTMLogoStackedInverted : CTMLogoStacked
      }, {
        srcset: inverted ? CTMLogoInlineInverted : CTMLogoInline
      }],
      className: className
    }
  });
};

CTMLogo.propTypes = {
  size: PropTypes.oneOf(['small', 'large']),
  inverted: PropTypes.bool,
  className: PropTypes.string
};
CTMLogo.defaultProps = {
  size: 'large',
  inverted: false,
  className: ''
};

exports.CTMLogo = CTMLogo;
exports.Logo = Logo;
